import { render, staticRenderFns } from "./SchoolDepartmentReport.vue?vue&type=template&id=05b11606&scoped=true"
import script from "./SchoolDepartmentReport.vue?vue&type=script&lang=js"
export * from "./SchoolDepartmentReport.vue?vue&type=script&lang=js"
import style0 from "./SchoolDepartmentReport.vue?vue&type=style&index=0&id=05b11606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b11606",
  null
  
)

export default component.exports